import { mediaQueryLarge, requestIdleCallback, startViewTransition, isMobileBreakpoint } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    // this.allcardToSetHeight = this.querySelectorAll('.product-grid__item--special[ref="cards[]"]');
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
    this.#resizeObserver();
    this.setupGridAttributeObserver();

  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }
  setupGridAttributeObserver() {
    const { grid } = this.refs || {};
    if (!grid) return;

    // Also keep the original MutationObserver for attribute changes on grid
    const mutationObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          this.style.setProperty('--height-to-set', this.setHeightToCard);
          this.#resizeObserver();
          break;

        }
      }
    });
    mutationObserver.observe(this, { attributes: false, childList: true, subtree: true });

    // Store observers if you want to disconnect later
    this._mutationObserver = mutationObserver;
  }

  #resizeObserver() {
    const { grid } = this.refs || {};
    if (!grid) return;

    let element = grid.querySelector('[ref="cardGallery"]');

    if (!element) return;
    const currentDevice = window.innerWidth >= 750 ? 'desktop' : 'mobile';
    const gridView = sessionStorage.getItem(`product-grid-view-${currentDevice}`);
    if (gridView) {
      // @ts-ignore
      document.querySelector(`input[type="radio"][name="grid-${currentDevice}"][value='${gridView}']`).checked = true;
    }

    // Use ResizeObserver to watch for width changes on the cardGallery element
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        if (width) {
          this.setHeightToCard = `${width * 1.6}px`
        }
        console.log(this.setHeightToCard);
        this.style.setProperty('--height-to-set', this.setHeightToCard);
        break;
      }
    });


    resizeObserver.observe(element);
    this._resizeObserver = resizeObserver;
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');
    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
